import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);



function DoughnutChart(props) {
    const { productData } = props;
    const data = {
        labels: ['아임레드 자몽', '소다얼려먹구싶오', '로망 타바코', '밀크폼 치즈밀크폼', '밀크폼 치즈밀크폼'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2],
                additionalData: [
                    { salesAmount: 12 * 20000 }, // 예: 12개 * 20000원
                    { salesAmount: 19 * 20000 }, // 예: 19개 * 20000원
                    { salesAmount: 3 * 20000 }, // 예: 19개 * 20000원
                    { salesAmount: 5 * 20000 }, // 예: 19개 * 20000원
                    { salesAmount: 2 * 20000 }, // 예: 19개 * 20000원
                    // ... 나머지 상품들의 판매 금액 데이터
                ],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',

                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',

                ],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed !== null) {
                            label += `${context.parsed}개,`;
                            const additionalData = context.dataset.additionalData[context.dataIndex];
                            label += `\n 총판매금액: ${additionalData.salesAmount}원`;


                            // 추가 데이터는 context.raw로 접근할 수 있습니다.
                            // 예를 들어, 추가 데이터가 판매 금액이라면 다음과 같이 사용할 수 있습니다.
                            // label += `${context.dataset.additionalData[context.dataIndex].salesAmount}원`;
                        }
                        return label;
                    }
                }
            }
        }
    };
    return <Doughnut data={data} options={options} />;
}

export default DoughnutChart;